module.exports = __webpack_public_path__ + "static/media/iq.894d2c0b.webp";